import { api_GET, api_POST, api_PUT } from "../api/_axios.js";

const concessionaria_api =
{
    getAll: function(){
        const promise = new Promise((resolve, reject) => { 
            api_GET(`concessionaria`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    getByUsuarioId: function(){
        const promise = new Promise((resolve, reject) => { 
            api_GET(`concessionaria/getByUsuarioId`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    getItem: function(id){
        const promise = new Promise((resolve, reject) => { 
            api_GET(`concessionaria/getItem/${id}`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    getConcessionariaRegionais: function(){
        const promise = new Promise((resolve, reject) => { 
            api_GET(`concessionaria/getConcessionariaRegionais`).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    post: function(json_submit){
        const promise = new Promise((resolve, reject) => { 
            api_POST(`concessionaria`, json_submit).then(result => {
                resolve(result)
            });
        });

        return promise;
    },

    put: function(json_submit){
        const promise = new Promise((resolve, reject) => { 
            api_PUT(`concessionaria`, json_submit).then(result => {
                resolve(result)
            });
        });

        return promise;
    },
}

export default concessionaria_api
